// extracted by mini-css-extract-plugin
export var fullWidthButton = "_oi-0";